/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'EMERGENCY_ALARM_SYSTEM_IS_FULLY_FUNCTIONING',
              'EMERGENCY_ALARM_SYSTEM_IS_REGULARLY_MAINTAINED_AND_INSPECTED_TE',
              'EMERGENCY_ALARM_SYSTEM_CAN_BE_HEARD_AND_SEEN_ACROSS_ALL_FACILIT',
              'EMERGENCY_ALARM_SYSTEM_BUTTONS_SWITCHES_PULL_STATIONS_ARE_EASIL',
              'EMERGENCY_ALARM_SYSTEM_IS_FITTED_WITH_A_BACK_UP_POWER_SOURCE_E_',
              'EMERGENCY_ALARM_SYSTEM_IS_AUTOMATIC_AND_CENTRALIZED',
              'EMERGENCY_ALARM_IS_DISTINCT_FROM_OTHER_ALARMS_SIGNALS_AND_IS_NO',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_any_of_the_following_safety_measures_in_place_3: valueSchema,
  },
}
